import { Link } from "react-router-dom";
import { useGetSiteBlogQuery } from '../../../../Redux/Apis/blogApi';
import { fa_dateـetime } from "../../../../utils/PersianNum";

function LastBlog({name,caption,site_id}) {
    const {data , isLoading } = useGetSiteBlogQuery(site_id)
    
    return ( 
        <>
        <div className="latest-news pt-150 pb-150">
            <div className="container">

                <div className="row">
                    <div className="col-lg-8 offset-lg-2 text-center">
                        <div className="section-title">	
                            {name && <h3><span className="orange-text">{name.split(" ")[0]}</span> {name.split(" ").slice(1).join(" ")}</h3>}
                            {caption && <p>{caption}</p>}
                        </div>
                    </div>
                </div>

                <div className="row">
                    {
                    isLoading ? "در حال بارگذاری" :
                    data && data.map((row,index) => 
                    <div className="col-lg-4 col-md-6" key={index}>
                        <div className="single-latest-news">
                            <Link to={`/post/${row.id}`}>
                                <div className="latest-news-bg" style={{backgroundImage: `url(${row.image})`}}></div>
                            </Link>
                            <div className="news-text-box">
                                <h3><Link to={`/post/${row.id}`}>
                                    {row.title}
                                </Link></h3>
                                <p className="blog-meta">
                                    <span className="author"><i className="fas fa-user"></i>مدیر</span>
                                    <span className="date"><i className="fas fa-calendar"></i>{fa_dateـetime(row.create_date)}</span>
                                </p>
                                <p className="excerpt">{row.excerpt}</p>
                                <Link to={`/post/${row.id}`} className="read-more-btn"><i className="fas fa-angle-left mr-1"></i>مشاهده کامل</Link>
                            </div>
                        </div>
                    </div>
                    )}
                </div>
                <div className="row">
                    <div className="col-lg-12 text-center">
                        <Link to="/blog" className="boxed-btn">مشاهده کامل</Link>
                    </div>
                </div>
            </div>
        </div>
        </>
     );
}

export default LastBlog;